import { render } from "./Login.vue?vue&type=template&id=a5d5f602&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=a5d5f602&scoped=true&lang=scss"
import "./Login.vue?vue&type=style&index=1&id=a5d5f602&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5d5f602"]])

export default __exports__